import React, { useState } from "react";
import { Image } from "antd";

const ImagePreview = (props) => {
  const {
    data = [],
    isIcon,
    iconColor = "#4D9CF4",
    component: Component,
  } = props;

  const [visible, setVisible] = useState(false);

  const evidence = data?.[0] || {};
  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={() => setVisible(!!evidence.url)}>
        {evidence.url ? <Component style={{ color: isIcon ? iconColor : "" }} /> : evidence.name}
      </div>
      <div style={{ display: "none" }}>
        {data && (
          <Image.PreviewGroup
            preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
          >
            {data.map((image, index) => (
              <Image key={index} src={image.url} alt={image.name} />
            ))}
          </Image.PreviewGroup>
        )}
      </div>
    </>
  );
};

export default ImagePreview;
